'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// Components


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _select = require('../../redux/modules/select');

var _alert = require('../../redux/modules/alert');

var _action = require('../../redux/modules/action');

var _modal = require('../../redux/modules/modal');

var _components = require('../../components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionList = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    actions: state.action.actions,
    attr: state.action.attr,
    orderNumber: state.booking.orderNumber,
    info: state.booking.data,
    selectRef: state.select.ref,
    selectShow: state.select.show
  };
}, {
  showAlert: _alert.show, setDNF: _action.setDNF, showReason: _modal.show, selectList: _select.selectList, setAttributes: _action.setAttributes, setAction: _action.setAction
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ActionList, _Component);

  function ActionList() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionList.__proto__ || (0, _getPrototypeOf2.default)(ActionList)).call.apply(_ref, [this].concat(args))), _this), _this.setActionAttr = function (evt) {
      var action = JSON.parse(evt.target.getAttribute('data-action'));
      _this.props.setAttributes(action);
    }, _this.setActionRequest = function () {
      var $props = _this.props;
      var attr = $props.attr;
      var method = attr ? attr.method : null;
      var path = attr ? attr.path : null;
      var action = attr ? attr.action : null;
      var orderNumber = $props.orderNumber;
      var info = $props.info;
      var nextAction = function nextAction() {
        var result = void 0;
        if (action === 'DriverNotFound') {
          result = $props.showAlert('dnf');
        } else {
          result = $props.showAlert('setaction');
        }
        return result;
      };
      var defaultAction = function defaultAction(defmethod, defpath, defbody) {
        $props.setAction(defmethod, defpath, defbody).then(function () {
          $props.checkOrderStatus();
          $props.selectList('');
        });
      };

      switch (action) {
        case 'DriverNotFound':
          $props.setDNF(orderNumber).then(function () {
            $props.checkOrderStatus();
            $props.selectList('');
          });
          break;
        case 'Cancel':
          $props.showReason();
          break;
        case 'Hold':
          $props.showReason();
          break;
        case 'Complete':
          var body = (0, _stringify2.default)({
            'receiver_name': 'Automation Tools',
            'resolution': 'receiver'
          });
          defaultAction(method, path, body);
          break;
        case 'Pickup':
          // bookingType == Instant
          if (info.data.bookingType === 'Instant') {
            $props.setAction(method, path).then(function () {
              $props.loadActions().then(function (res) {
                var nextaction = res.data.actionList.data.actions[0];
                defaultAction(nextaction.method, nextaction.path);
              });
            });
          } else {
            defaultAction(method, path);
          }
          break;
        default:
          defaultAction(method, path);
          break;
      }
      nextAction();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actions = _props.actions,
          info = _props.info,
          styles = _props.styles,
          selectShow = _props.selectShow,
          selectRef = _props.selectRef,
          showHideOption = _props.showHideOption;

      var notconfim = true;
      var infodata = info ? info.data : null;
      var infoactions = actions ? actions.data : null;
      var actionData = infoactions ? actions.data.actions : null;
      var bookingType = infodata ? info.data.bookingType : null;
      var actionList = actionData ? actionData.map(function (val, key) {
        var actionObj = (0, _stringify2.default)(val);
        var isPicked = infodata.status === 'Item Picked';
        var isEnrouteDrop = infodata.status === 'Enroute Drop';
        var isHold = infodata.status === 'On Hold';
        // const onHold = val.action === 'Hold';
        var onCancel = val.action === 'Cancel';
        var onComplete = val.action === 'Complete';
        var list = void 0;
        if (isHold && bookingType === 'Instant' && onComplete) {
          list = '';
        } else if (onCancel && isPicked || onCancel && isEnrouteDrop || onCancel && isHold) {
          list = '';
        } else {
          list = _react2.default.createElement(
            'li',
            {
              onClick: showHideOption,
              key: key, 'data-value': val.action_name,
              'data-action': actionObj,
              'data-select': 'selectAction' },
            val.action_name
          );
        }
        return list;
      }) : null;
      var notFoundAction = infodata && infodata.status === 'Finding Driver' ?
      // add not found driver action
      _react2.default.createElement(
        'li',
        {
          onClick: showHideOption,
          'data-value': 'Driver Not Found',
          'data-action': '{"action":"DriverNotFound"}',
          'data-select': 'selectAction' },
        'Driver Not Found'
      ) : null;
      // check if action list has been loaded
      if (actionData) {
        notconfim = false;
        if (actionData.length === 0) {
          notconfim = true;
        }
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _components.Select,
          { styles: styles },
          _react2.default.createElement(
            'div',
            null,
            selectShow && selectRef === 'selectAction' ? _react2.default.createElement(
              'ul',
              { className: styles.listWrapper },
              _react2.default.createElement(
                'li',
                { onClick: showHideOption, 'data-value': null, 'data-select': 'selectAction' },
                '- Select Action -'
              ),
              notFoundAction,
              actionList
            ) : null
          )
        ),
        _react2.default.createElement(_components.Button, { text: 'Confirm', onclick: this.setActionRequest, disabled: notconfim })
      );
    }
  }]);
  return ActionList;
}(_react.Component), _class2.propTypes = {
  // states
  actions: _propTypes2.default.object,
  attr: _propTypes2.default.object,
  orderNumber: _propTypes2.default.string,
  info: _propTypes2.default.object,
  selectRef: _propTypes2.default.string,
  selectShow: _propTypes2.default.bool,
  // actions dispatch
  setDNF: _propTypes2.default.func,
  selectList: _propTypes2.default.func,
  setAction: _propTypes2.default.func,
  setAttributes: _propTypes2.default.func,
  showAlert: _propTypes2.default.func,
  showReason: _propTypes2.default.func,
  // actions custom props (set on calling the component)
  checkOrderStatus: _propTypes2.default.func,
  loadActions: _propTypes2.default.func,
  showHideOption: _propTypes2.default.func,
  styles: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = ActionList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ActionList/ActionList.js
// module id = 857
// module chunks = 0